// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  username: __t.string(),
  displayName: __t.string().name("display_name"),
  countryCode: __t.string().name("country_code"),
  profilePictureId: __t.option(__t.string()).name("profile_picture_id"),
  eloRating: __t.i32().name("elo_rating"),
  gamesWon: __t.u32().name("games_won"),
  gamesLost: __t.u32().name("games_lost"),
  lastActiveAt: __t.u64().name("last_active_at"),
  isGuest: __t.bool().name("is_guest"),
  email: __t.option(__t.string()),
  passwordHash: __t.option(__t.string()).name("password_hash"),
  createdAt: __t.u64().name("created_at"),
  bio: __t.option(__t.string()),
  eloRanked: __t.i32().name("elo_ranked"),
  eloRace: __t.i32().name("elo_race"),
  eloTurnTactics: __t.i32().name("elo_turn_tactics"),
  peakEloRanked: __t.i32().name("peak_elo_ranked"),
  rankedWins: __t.u32().name("ranked_wins"),
  rankedLosses: __t.u32().name("ranked_losses"),
  rankedGamesPlayed: __t.u32().name("ranked_games_played"),
  raceMmWins: __t.u32().name("race_mm_wins"),
  raceMmLosses: __t.u32().name("race_mm_losses"),
  raceMmGamesPlayed: __t.u32().name("race_mm_games_played"),
  ttMmWins: __t.u32().name("tt_mm_wins"),
  ttMmLosses: __t.u32().name("tt_mm_losses"),
  ttMmGamesPlayed: __t.u32().name("tt_mm_games_played"),
  googleId: __t.option(__t.string()).name("google_id"),
  currentWinStreak: __t.u32().name("current_win_streak"),
  bestWinStreak: __t.u32().name("best_win_streak"),
  beginnerWins: __t.u32().name("beginner_wins"),
  intermediateWins: __t.u32().name("intermediate_wins"),
  expertWins: __t.u32().name("expert_wins"),
  totalXp: __t.u64().name("total_xp"),
  coinsBalance: __t.i64().name("coins_balance"),
  vipTier: __t.u32().name("vip_tier"),
  glickoMu: __t.i32().name("glicko_mu"),
  glickoRd: __t.i32().name("glicko_rd"),
  glickoSigma: __t.i32().name("glicko_sigma"),
  rankPoints: __t.i32().name("rank_points"),
  placementGamesPlayed: __t.u32().name("placement_games_played"),
  placementCompleted: __t.bool().name("placement_completed"),
  firstWinClaimedAt: __t.u64().name("first_win_claimed_at"),
  demotionShields: __t.u32().name("demotion_shields"),
  lastPromotionAt: __t.u64().name("last_promotion_at"),
});
